import axios from "axios";
import { REACT_APP_API_TENANTS_URL } from "../constants";
import { AUTH_TOKEN, checkAPISuccess, getDomainUrl, manageServiceError } from "../utils/helpers";
import { requestsFor } from "./headerService";
import { showCustomError } from "../utils/notificationService";

const axiosInstance = axios.create({
  baseURL: `${REACT_APP_API_TENANTS_URL}/tenants`,
});

const axiosInstanceBase = axios.create({
  baseURL: `${REACT_APP_API_TENANTS_URL}`,
});

const requests = requestsFor(axiosInstanceBase);

const path = {
  resetPassword: "/resetPassword",
  tenantDetails: "/getTenantDetail",
  authMethod: "/getAuthMethod",
  tennantLists: "/tenantlist",
  OSList: '/getOsList',
  getCountofEpmUserByEndpoint: "/getCountofEpmUserByEndpoint",
  getCountofEpmUserGroupByEndpoint: "/getCountofEpmUserGroupByEndpoint",
  // Bare path, like every other entry here. REACT_APP_TENANTS_API_URL already
  // carries whatever prefix the deployment needs (on-prem injects
  // ".../api/v1/tenants"), so spelling it out again doubles the segment.
  listPlatformUsers: "/listPlatformUsers",
}

// Platform users = the people with an account on this tenant (role, enrolled MFA
// factors, account status). Server-side paginated; `counts` carries the status
// breakdown for the whole search/roles scope.
export async function getPlatformUserList({ payload = {}, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.listPlatformUsers, {
      url: getDomainUrl(),
      roles: ["ADMIN", "ENDUSER"],
      status: "all",
      search: "",
      page: 1,
      pageSize: 10,
      ...payload,
    });
    if (checkAPISuccess(response)) {
      onSuccess && onSuccess(response);
    } else {
      onFailure && onFailure(response);
    }
  } catch (error) {
    manageServiceError(error, onFailure, "Platform User List");
  }
}

export async function getAuthMethod({ payload = {}, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.authMethod, {
      ...payload,
      url: getDomainUrl(),
    });
    if (checkAPISuccess(response)) {
      onSuccess && onSuccess(response);
    } else {
      onFailure && onFailure(response);
    }
  } catch (error) {
    showCustomError("Tenant Information", error?.response?.data?.message);
    onFailure && onFailure(error?.response);
  }
}

export async function getTenantDetails({ payload = {}, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.tenantDetails, payload);
    if (checkAPISuccess(response)) {
      onSuccess && onSuccess(response);
    } else {
      onFailure && onFailure(response);
    }
  } catch (error) {
    showCustomError("Tenant Information", error?.response?.data?.message);
    onFailure && onFailure(error?.response);
  }
}

export async function fetchTenent({ payload = {}, onSuccess, onFailure }) {
  try {
    const { data: response } = await axiosInstanceBase.post(
      "/tenantlist",
      { ...payload },
      {
        headers: {
          withCredentials: true,
          "X-Authorization": AUTH_TOKEN(),
        },
      }
    );

    if (checkAPISuccess(response)) {
      onSuccess && onSuccess(response);
    } else {
      onFailure && onFailure(response);
    }
  } catch (error) {
    showCustomError("Tenant Information", error?.response?.data?.message);
    onFailure && onFailure(error?.response);
  }
}

export async function getOSList({ payload = {}, onSuccess, onFailure }) {
  try {
    const { data: response } = await requests.post(path.OSList, payload);
    if (checkAPISuccess(response)) {
      onSuccess && onSuccess(response);
    } else {
      onFailure && onFailure(response);
    }
  } catch (error) {
    manageServiceError(error, onFailure, "OS List");
  }
}




// MFA Provider

export const getMFAProvider = async ({ payload, onSuccess, onError }) => {
  try {
    const { data, status } = await axiosInstance.post("/mfaconfig/get", payload);
    if (status === 200) {
      onSuccess(data);
    }
  } catch (error) {
    onError(error);
  }
};

export const setMFAProvider = async ({ payload, onSuccess, onError }) => {
  try {
    const { data, status } = await axiosInstance.post("/mfaconfig/add", payload);
    if (status === 200) {
      onSuccess(data);
    }
  } catch (error) {
    onError(error);
  }
};

export const getAuthFactors = async ({ payload, onSuccess, onError }) => {
  try {
    const { data, status } = await axiosInstance.post("/getauthfactors", payload);
    if (status === 200) {
      onSuccess(data);
    }
  } catch (error) {
    onError(error);
  }
};

export const setAuthFactorsConfig = async ({ payload, onSuccess, onError }) => {
  try {
    const { data, status } = await axiosInstance.post("/setauthfactors", payload);
    if (status === 200) {
      onSuccess(data);
    }
  } catch (error) {
    onError(error);
  }
};

export const getDefaultIssuerforTenant = async ({ payload, onSuccess, onError }) => {
  try {
    const { data, status } = await axiosInstanceBase.post("/setDefaultIssuerForTenant", payload);
    if (status === 200) {
      onSuccess(data);
    }
  } catch (error) {
    onError(error);
  }
};

export const getIssuerList = async ({ payload, onSuccess, onError }) => {
  try {
    const { data, status } = await axiosInstanceBase.post("/getIssuerList", payload);
    if (status === 200) {
      onSuccess(data);
    }
  } catch (error) {
    onError(error);
  }
};

export const SetDefaultJumpserver = async ({ payload, onSuccess, onError }) => {
  try {
    const { data, status } = await axiosInstanceBase.post("/SetDefaultJumpserver", payload);
    if (status === 200) {
      onSuccess(data);
    }
  } catch (error) {
    onError(error);
  }
};
